// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3wJ1R","inner":"Footer_inner__XQMHY"};